import StaffChatPanel from "@/components/StaffChatPanel";

/**
 * Pop-out window route. Renders the chat panel without any portal chrome —
 * full-height, no nav, ideal for keeping live chat open in a side window
 * while continuing to use the rest of the staff portal in the main tab.
 */
export default function StaffChatPopoutPage() {
  return (
    <div className="bg-slate-50 min-h-screen">
      <StaffChatPanel embedded={false} />
    </div>
  );
}
